import { Controller } from "@hotwired/stimulus";
import Rails from 'rails-ujs';

export default class extends Controller {
  initialize() {
    if (!this.modalBackdrop) {
      let backdrop = document.createElement('div');
      backdrop.id = 'remote-modal';
      backdrop.classList.add('modal-backdrop');
      document.body.appendChild(backdrop);
    }
  }

  get body() {
    return document.body;
  }

  get modal() {
    const selector = this.data.get('id') || 'div.modal';
    return document.querySelector(selector);
  }

  get modalBackdrop() {
    return document.querySelector('#remote-modal');
  }

  close() {
    this.body.classList.remove('modal-open');
    this.modal.classList.remove('in');
    this.modalBackdrop.classList.remove('in');
    setTimeout(() => {
      this.modal.classList.remove('fade');
      this.modalBackdrop.classList.remove('fade');
    }, 200);
  }

  open() {
    if (this.data.get('url')) {
      this.openRemote();
    }
  }

  addBackground() {
    if (this.modalBackdrop && this.modal) {
      this.body.classList.add('modal-open');
      this.modal.classList.add('fade');
      this.modalBackdrop.classList.add('fade');
      setTimeout(() => {
        this.modal.classList.add('in');
        this.modalBackdrop.classList.add('in');
      }, 20);
    }
  }

  onOpen() {
    this.addBackground();
    document.querySelectorAll('[data-dismiss="modal"]').forEach(target => {
      target.addEventListener('click', this.close.bind(this));
    });
  }

  openRemote() {
    Rails.ajax({
      type: 'GET',
      dataType: 'script',
      url: this.data.get('url'),
      success: data => {
        this.onOpen();
      }
    });
  }
}
